import React, { ReactElement, useEffect, useMemo } from 'react';
import { Form } from 'formik';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import { DataCollectionValues } from '../../../../../types';
import FormControl from '../../../../components/Form/FormControl';
import StepHeader from '../../../../components/Layout/StepHeader';
import InfoCard from '../../../../components/Layout/InfoCard';
import { TextsStepAvgHeatTransferOfBuildingPENB } from '../../../../../data/dictionary';

interface FormError {
    averageHeatTransferCoefficient?: string;
}

const stepValidation = (values: DataCollectionValues) => {
    const errors: FormError = {};

    if (!values.averageHeatTransferCoefficient || Number(values.averageHeatTransferCoefficient) < 0) {
        errors.averageHeatTransferCoefficient = 'Povinné pole';
    }

    return errors;
};

const StepAvgHeatTransferOfBuildingPENB = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    const errors = useMemo(() => stepValidation(values), [values]);
    useEffect(() => {
        completeStep && completeStep(!Object.keys(errors).length);
    }, [errors]);

    return (
        <Form>
            <StepHeader
                title="Průměrný součinitel prostupu tepla budovy"
                subtitle="Vyplňte prosím hodnotu z průkazu Vaší budovy"
            />
            <InfoCard img="prostup.jpg" texts={TextsStepAvgHeatTransferOfBuildingPENB} />
            <div className="otz-house-info otz-house-info-small">
                <div className="otz-house-info__item">
                    <div className="otz-house-info__inner">
                        <div className="otz-house-info__title-small">Průměrný součinitel prostupu tepla</div>
                        <div className="otz-house-info__select relative">
                            <FormControl
                                name="averageHeatTransferCoefficient"
                                id="averageHeatTransferCoefficient"
                                type="number"
                                tag="input"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.averageHeatTransferCoefficient}
                                error={errors.averageHeatTransferCoefficient}
                            />
                            <div className="wiz-form-text">
                                W/(m<sup>2</sup>K)
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepAvgHeatTransferOfBuildingPENB;
